import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const helpRoutes: RouteRecordRaw[] = [
  {
    path: routes.HELP,
    name: 'HELP',
    component: () => import('./HelpPage.vue'),
    meta: { requiresAuth: true },
  },
]

// Public read-only viewers for the legal documents the Help module publishes.
// Registered in `publicRoutes` — reachable from the login / OTP footers before
// the operator has a token, and from the app-shell footer afterwards.
export const legalRoutes: RouteRecordRaw[] = [
  {
    path: routes.LEGAL_DOC,
    name: 'LEGAL_DOC',
    component: () => import('./LegalDocPage.vue'),
  },
]
